import * as aj from "../aj/index";
import {createAsyncAction} from "../utils/ajex";
import * as SessionApi from "../api/session";
import {alert, hideLoader, showLoader, toast} from "../plugins";
import M from "../strings";
import _ from "underscore";
import {LOGIN, LOGOUT, RESUME_SESSION} from "./types";
import * as NotificationCenter from "../utils/notificationCenter";

export const login = createAsyncAction(LOGIN, data => {
    if (_.isEmpty(data.mail) || _.isEmpty(data.password)) {
        alert(M("problemOccoured"), M("mailAndPasswordRequired"), "warning")
        return;
    }

    aj.dispatch({
        type: LOGIN
    })

    showLoader()
    return new Promise((resolve, reject) => {
        SessionApi.start(data.mail, data.password)
        .then(user => {
            hideLoader()
            toast(M("welcome") + " " + user.name);

            login.complete({user})
            performLoginUserAction(user)
            resolve();
        })
        .catch(e => {
            hideLoader()
            alert(M("ooops"), M("badLogin"), "error")

            login.fail()
            reject();
        })
    })
});

function performLoginUserAction (user) {
    NotificationCenter.invoke("login", user);
}

export const resumeSession = createAsyncAction(RESUME_SESSION, data => {
    aj.dispatch({
        type: RESUME_SESSION
    })

    return new Promise((resolve, reject) => {
        SessionApi.resume()
        .then(user => {
            hideLoader()
            toast(M("welcome") + " " + user.name);

            performLoginUserAction(user)
            resumeSession.complete({user})
            
            resolve();
        })
        .catch(e => {
            hideLoader()

            resumeSession.fail()
            reject();
        })
    })
});

export const logout = aj.createAction(LOGOUT, data => {
    return new Promise((resolve, reject) => {
        SessionApi.destroy()
        .then(() => {
            aj.dispatch({
                type: LOGOUT
            })

            NotificationCenter.invoke("logout");
            resolve();
        })
    })
});

